import { createRoute } from "@tanstack/react-router";
import { Route as dashboardRoute } from "../dashboard";
import ComprehensiveLibraryView from "@/components/library/ComprehensiveLibraryView";
import { $api } from "@/lib/api";

export const Route = createRoute({
  getParentRoute: () => dashboardRoute,
  path: "library",
  component: ComprehensiveLibraryView,
  loader: ({ context }) => {
    if (!localStorage.getItem("backendToken")) return;
    context.queryClient.prefetchQuery(
      $api.queryOptions("get", "/api/v1/precedents"),
    );
  },
});
